app.popover = null;

(($) => {

    $(document).ready(() => {

        app.popover = () => {

            $('.popover').each(function(i, e) {

                let label = $(this).attr('title');
                let html = $(this).attr('html-id');
                

                if(typeof label !== 'undefined' && label.length > 0) {
                    tippy(this, { content: label });
                }

                if(typeof html !== 'undefined' && html.length > 0) {
                    console.log(html, $('#' + html).html());
                    tippy(this, { 
                        content: $('#' + html).html(), 
                        allowHTML: true,
                        interactive: true
                    });
                }

            });

        };

        app.popover();
    });
        
})(jQuery);